import React from "react";
import { UIFlightData } from "@flights/types";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller";
import Frame from "../../../../../Frame";
import { Text } from "@bookingcom/bui-react";
import flights_web_condensed_extras_fd_ddot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_ddot";

const useUpgradeFareInfoDesktop = (flight: UIFlightData) => {
  const { header, subheader, fareInfoContent } = useUpgradeFareInfoController(flight);

  if (!fareInfoContent) return undefined;

  const isCondensed = !!flights_web_condensed_extras_fd_ddot.trackWithDefaultStage();

  return {
    header,
    subheader,
    content: (
      <Frame direction="row" justifyContent="space-between">
        <Frame>
          <Text variant="body_2">{fareInfoContent.content}</Text>
          {!isCondensed && <Text variant="body_2">{fareInfoContent.price}</Text>}
        </Frame>
        <Frame ml={isCondensed ? 2 : 4}>
          <Text variant="body_2" align="right" wrap="nowrap">
            {isCondensed ? fareInfoContent.price : fareInfoContent.supportText}
          </Text>
        </Frame>
      </Frame>
    )
  };
};

export default useUpgradeFareInfoDesktop;
